// Apply a composed Quill change-delta (ops array) to the live document, using
// the Yjs path under live-collab (mirrors handleCopyOlderConfirm) or Quill otherwise.
export function applyOpsToEditor({ ops, yText, yDoc, editor }) {
  if (!ops || ops.length === 0) return;
  if (yText && yDoc?.transact) {
    yDoc.transact(() => { yText.applyDelta(ops); });
  } else if (editor?.updateContents) {
    editor.updateContents(ops);
  }
}
